export default "__VITE_ASSET__CR1ZJ9Ic__"